import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/companies_/$companyId/onboarding')({
  staticData: { title: 'Onboarding' },
})
